import React, { useState, useEffect, useRef } from 'react';
import PrivateLayout from '../../layouts/PrivateLayout/PrivateLayout';
import { Tabs, TabsRef } from 'flowbite-react';
import BusinessProfile from './SettingsTabs/BusinessProfile/BusinessProfile';
import PayoutAccount from './SettingsTabs/PayoutAccount/PayoutAccount';
import UserSubsidiaries from './SettingsTabs/UserSubsidiaries/UserSubsidiaries';
import Preferences from './SettingsTabs/Preferences/Preferences';
import AuditTrail from './SettingsTabs/AuditTrails/AuditTrail';
import ApiKeys from './SettingsTabs/ApiKeys/ApiKeys';
import RoleAndPermission from './SettingsTabs/RolesAndPermissions/RoleAndPermission';
import Users from './SettingsTabs/Users/Users';
import PinSettings from './SettingsTabs/PinSettings/PinSettings';

const Settings = () => {
    const [activeTab, setActiveTab] = useState<number>(0);
    const tabsRef = useRef<TabsRef>(null);

    useEffect(() => {
        const storedTabIndex = localStorage.getItem('activeTab');

        if (storedTabIndex !== null) {
            setActiveTab(Number(storedTabIndex));
        }
    }, [activeTab]);

    const handleTabChange = (index: number) => {
        setActiveTab(index);
        localStorage.setItem('activeTab', index.toString());
    };

    return (
        <PrivateLayout>
            <div className='px-6 py-6'>
                <div>
                    <p className='text-xl'>Settings</p>
                </div>
                <hr />
                <div className='my-6 w-full'>
                    <Tabs
                        style="underline"
                        className='w-full shadow-none'
                        onActiveTabChange={(activeTab) => handleTabChange(activeTab)}
                        ref={tabsRef}
                        theme={{
                            tablist: {
                              tabitem: {
                                base: 'flex items-center justify-center p-4 text-sm font-medium first:ml-0 disabled:cursor-not-allowed disabled:text-gray-400 disabled:dark:text-gray-500 focus:ring-0  focus:outline-none rounded-t-lg border-b-2 border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-600',
                              },
                            },
                          }}
                    >
                        <Tabs.Item title="Business Profile" onClick={() => tabsRef.current?.setActiveTab(0)} active={activeTab === 0}>
                            <BusinessProfile />
                        </Tabs.Item>
                        <Tabs.Item title="Payout Account" onClick={() => tabsRef.current?.setActiveTab(1)} active={activeTab === 1}>
                            <PayoutAccount />
                        </Tabs.Item>
                        <Tabs.Item title="Roles and Permissions" onClick={() => tabsRef.current?.setActiveTab(2)} active={activeTab === 2}>
                            <RoleAndPermission />
                        </Tabs.Item>
                        <Tabs.Item title="Users" onClick={() => tabsRef.current?.setActiveTab(3)} active={activeTab === 3}>
                            <Users />
                        </Tabs.Item>
                        <Tabs.Item title="Preferences" onClick={() => tabsRef.current?.setActiveTab(4)} active={activeTab === 4}>
                            <Preferences />
                        </Tabs.Item>
                        <Tabs.Item title="Audit trails" onClick={() => tabsRef.current?.setActiveTab(5)} active={activeTab === 5}>
                            <AuditTrail />
                        </Tabs.Item>
                        <Tabs.Item title="API Keys and Webhooks" onClick={() => tabsRef.current?.setActiveTab(6)} active={activeTab === 6}>
                            <ApiKeys />
                        </Tabs.Item>
                        <Tabs.Item title="Pin Settings" onClick={() => tabsRef.current?.setActiveTab(7)} active={activeTab === 7}>
                            <PinSettings />
                        </Tabs.Item>
                    </Tabs>
                </div>
            </div>
        </PrivateLayout>
    );
};

export default Settings;
